import type { TutorialDefinition, TutorialId, TutorialStep } from './types'
import { FIRST_RUN_DEFINITION } from './firstRun'

export function getDefinition(id: TutorialId): TutorialDefinition {
  switch (id) {
    case 'first_run':
      return FIRST_RUN_DEFINITION
    default:
      return FIRST_RUN_DEFINITION
  }
}

export function findStepIndex(def: TutorialDefinition, stepId?: string | null): number {
  if (!stepId) return 0
  const idx = def.steps.findIndex((s) => s.id === stepId)
  return idx >= 0 ? idx : 0
}

export function getStep(def: TutorialDefinition, index: number): TutorialStep | null {
  if (index < 0 || index >= def.steps.length) return null
  return def.steps[index]
}
